import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCMKeWs8Dc4vZaKc-8CaVNhCetbqEGlghQ",
  authDomain: "shruti-eye-care-and-opticals.firebaseapp.com",
  projectId: "shruti-eye-care-and-opticals",
  storageBucket: "shruti-eye-care-and-opticals.firebasestorage.app",
  messagingSenderId: "390843022183",
  appId: "1:390843022183:web:9478c7186199218602cdc2",
  measurementId: "G-BD21D9GXN5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;